import { useQuery } from "react-query";
import { useSelector } from "react-redux";
import authAPI from "../authAPI";
import { selectAuthUserId } from "../../features/auth/AuthSlice";

export const useMyGroupMemberships = (includeInactive = false) => {
  const userId = useSelector(selectAuthUserId);

  return useQuery(
    ["user", "me", "group-memberships", includeInactive],
    () => authAPI.getMyGroupMemberships(includeInactive),
    {
      enabled: !!userId,
    }
  );
};
